module.exports = __webpack_public_path__ + "img/mini-portrait.d9bfe46.png";